export const LayerContextEnum = {
    FuelStation: 1,
    EletricStation: 2,
    Workshop: 3,
    AutoParts: 4,
    Accioly: 8,
    Acdelco: 9,
    MotoWorkShop: 10,
    MotoParts: 11,
};



// WEBPACK FOOTER //
// ./src/enuns/layerContext.enum.js